import React from 'react';
import { useParams } from 'react-router-dom';
import Section from './Section';
import CodeHighlighter from './CodeSnippet';
import Info from './Info';
import Note from './Note';

const Article = ({ sections }) => {
  const { articleId } = useParams(); // Get the article ID from the URL

  // Find the selected article based on its ID
  const selectedArticle = sections
    .flatMap(section => section.articles)
    .find(article => article.id === articleId);

  if (!selectedArticle) return <p>Article not found</p>;

  // Render each section based on its type
  const renderSection = (section, index) => {
    switch (section.type) {
      case 'text':
        return (
          <Section key={index} title={section.title}>
            <p>{section.content}</p>
          </Section>
        );
      case 'code':
        return (
          <Section key={index} title={section.title}>
            <CodeHighlighter code={section.content} language="javascript" />
          </Section>
        );
      case 'info':
        return <Info key={index}>{section.content}</Info>;
      case 'note':
        return <Note key={index}>{section.content}</Note>;
      default:
        return null;
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">{selectedArticle.title}</h1>
      {selectedArticle.sections.map((section, index) => renderSection(section, index))}
    </div>
  );
};

export default Article;
